var _g, _g2, _g3, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "app-store",
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.12,
    height: 102.12,
    viewBox: "0 0 102.12 102.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5211",
    "data-name": "Group 5211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5210",
    "data-name": "Group 5210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8772",
    "data-name": "Path 8772",
    d: "M81.177,0H20.943A20.966,20.966,0,0,0,0,20.943V81.177A20.966,20.966,0,0,0,20.943,102.12H81.177A20.966,20.966,0,0,0,102.12,81.177V20.943A20.966,20.966,0,0,0,81.177,0ZM96.136,81.177A14.976,14.976,0,0,1,81.177,96.136H20.943A14.976,14.976,0,0,1,5.984,81.177V20.943A14.976,14.976,0,0,1,20.943,5.984H81.177A14.976,14.976,0,0,1,96.136,20.943Z",
    fill: "#ededed"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5213",
    "data-name": "Group 5213",
    transform: "translate(17.053 20.944)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5212",
    "data-name": "Group 5212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8773",
    "data-name": "Path 8773",
    d: "M129.409,108.7a4.986,4.986,0,0,0-9.135-1.2l-.767,1.329-.767-1.329a4.992,4.992,0,0,0-6.811-1.825h0a4.992,4.992,0,0,0-1.825,6.812l3.646,6.315L100.3,142.1H90.486a4.986,4.986,0,1,0,0,9.973h37.868L122.6,142.1H111.81l17.1-29.618A4.953,4.953,0,0,0,129.409,108.7Z",
    transform: "translate(-85.5 -105.006)",
    fill: "#ededed"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5215",
    "data-name": "Group 5215",
    transform: "translate(53.363 38.727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5214",
    "data-name": "Group 5214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8774",
    "data-name": "Path 8774",
    d: "M294.265,213.48h-9.809l-11.151-19.314-5.758,9.973,17.313,29.987a4.954,4.954,0,0,0,3.028,2.324,5.015,5.015,0,0,0,1.3.172,4.99,4.99,0,0,0,4.31-7.482l-3.284-5.688h4.051a4.986,4.986,0,0,0,0-9.973Z",
    transform: "translate(-267.548 -194.166)",
    fill: "#ededed"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5217",
    "data-name": "Group 5217",
    transform: "translate(22.14 72.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5216",
    "data-name": "Group 5216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8775",
    "data-name": "Path 8775",
    d: "M112.651,361l-.981,1.7a4.986,4.986,0,0,0,8.637,4.986L124.166,361Z",
    transform: "translate(-111.003 -361)",
    fill: "#ededed"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.e5a3d60f.svg";
export { ForwardRef as ReactComponent };